import { QueryFunctionContext } from "@tanstack/react-query";

import {
  DriverLocationResponse,
  DriverRouteType,
  UserSearch,
} from "@web-app/types";
import http from "@web-app/utils/http";

export const searchDrivers = async ({
  searchTerm,
  signal,
  status,
}: {
  searchTerm: string;
  signal?: AbortSignal;
  status?: "OFFLINE" | "ONLINE";
}) => {
  return http
    .get<UserSearch[] | null>(
      `/driversv3?search=${searchTerm}&status=${status}`,
      {
        signal,
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const getDriversLocations = async (driverIds: string[]) => {
  return http
    .post<DriverLocationResponse>(`/driverLocationsv2`, { driverIds })
    .then((res) => {
      return res.data;
    });
};

export const getDriversByIds = async (driverIds: string[]) => {
  return http.post<UserSearch[]>(`/driversv3`, { driverIds }).then((res) => {
    return res.data;
  });
};

export const getDriverRoute = async ({
  queryKey,
  signal,
}: QueryFunctionContext) => {
  const [, orderId] = queryKey as [string, string];
  return http
    .get<DriverRouteType>(`orders/${orderId}/driverRoute`, {
      signal,
    })
    .then((res) => {
      return res.data;
    });
};
